import useConstant from 'use-constant';
import AwesomeDebouncePromise from 'awesome-debounce-promise';

const useDebouncePromise = (fn, wait, options) => {
  const debouncedFn = useConstant(() => AwesomeDebouncePromise(fn, wait, options));
  return debouncedFn;
};

export default useDebouncePromise;
